module.exports = __webpack_public_path__ + "img/battery_online.84751f22.svg";